(() => {
  'use strict';
  if (window.UnchemedHome) return;
  const motion = matchMedia('(prefers-reduced-motion: reduce)');
  const instances = new WeakMap();
  const behavior = () => motion.matches ? 'instant' : 'smooth';
  function init(root = document) {
    const result = root.querySelector('#results');
    if (result && !instances.has(result)) {
      const source = result.closest('.unc-restored')?.querySelector('[data-rh-reviews]');
      let reviews = [];
      try { reviews = JSON.parse(source?.textContent || '[]'); } catch (_) {}
      const thumbs = [...result.querySelectorAll('[data-rh-review]')];
      let current = 0;
      const show = index => {
        if (!reviews.length) return;
        current = (index + reviews.length) % reviews.length;
        const data = reviews[current], image = result.querySelector('#rvbig');
        image.src = data.image; image.removeAttribute('srcset');
        result.querySelector('#rvq').textContent = data.quote;
        result.querySelector('#rvby').textContent = data.author;
        result.querySelector('#rvtags').replaceChildren(...data.tags.map(value => { const tag = document.createElement('span'); tag.textContent = value; return tag; }));
        thumbs.forEach((thumb,i) => { thumb.classList.toggle('on',i === current); thumb.setAttribute('aria-pressed',String(i === current)); });
        const thumb = thumbs[current], row = result.querySelector('.rvth');
        if (thumb && row) {
          const t = thumb.getBoundingClientRect(), r = row.getBoundingClientRect();
          if (t.left < r.left) row.scrollBy({left:t.left-r.left,behavior:behavior()});
          else if (t.right > r.right) row.scrollBy({left:t.right-r.right,behavior:behavior()});
        }
      };
      thumbs.forEach((thumb,i) => thumb.addEventListener('click',() => show(i)));
      result.querySelectorAll('[data-rh-review-dir]').forEach(button => button.addEventListener('click',() => show(current + Number(button.dataset.rhReviewDir))));
      result.dataset.rhReady = 'true'; instances.set(result,() => {});
    }
    const science = root.querySelector('#science');
    if (science && !instances.has(science)) {
      const tabs = [...science.querySelectorAll('[data-rh-science]')];
      const panes = [...science.querySelectorAll('.scipane')];
      const select = (index,focus = false) => {
        tabs.forEach((tab,i) => { tab.classList.toggle('on',i === index); tab.setAttribute('aria-selected',String(i === index)); tab.tabIndex = i === index ? 0 : -1; });
        panes.forEach((pane,i) => { pane.hidden = i !== index; pane.classList.toggle('on',i === index); });
        if (focus) tabs[index].focus({preventScroll:true});
      };
      tabs.forEach((tab,i) => {
        tab.addEventListener('click',() => select(i));
        tab.addEventListener('keydown',event => {
          if (!['ArrowLeft','ArrowRight','Home','End'].includes(event.key)) return;
          event.preventDefault(); select(event.key === 'Home' ? 0 : event.key === 'End' ? tabs.length - 1 : (i + (event.key === 'ArrowRight' ? 1 : -1) + tabs.length) % tabs.length,true);
        });
      });
      const xray = science.querySelector('[data-rh-xray]');
      if (xray) {
        let value = 50, active = null;
        const set = number => {
          value = Math.min(100,Math.max(0,number));
          xray.querySelector('.top').style.clipPath = `inset(0 0 0 ${value}%)`;
          xray.querySelector('.handle').style.left = value + '%';
          xray.setAttribute('aria-valuenow',String(Math.round(value)));
        };
        const move = event => { const rect = xray.getBoundingClientRect(); if (rect.width) set((event.clientX-rect.left)/rect.width*100); };
        xray.addEventListener('pointerdown',event => { if (event.button !== 0) return; active = event.pointerId; if (event.pointerType === 'mouse') { xray.setPointerCapture(event.pointerId); move(event); } });
        xray.addEventListener('pointermove',event => { if (active === event.pointerId) move(event); });
        ['pointerup','pointercancel','lostpointercapture'].forEach(name => xray.addEventListener(name,() => {active = null;}));
        xray.addEventListener('click',move);
        xray.addEventListener('keydown',event => {
          if (!['ArrowLeft','ArrowRight','Home','End'].includes(event.key)) return;
          event.preventDefault(); set(event.key === 'Home' ? 0 : event.key === 'End' ? 100 : value + (event.key === 'ArrowRight' ? 5 : -5));
        }); set(50);
      }
      instances.set(science,() => {});
    }
    const contrast = root.querySelector('#mben');
    if (contrast && !instances.has(contrast)) {
      const buttons = [...contrast.querySelectorAll('[data-rh-contrast]')];
      function select(index) {
        contrast.classList.toggle('on',index === 1);
        buttons.forEach((button,i) => {button.classList.toggle('on',index === i);button.setAttribute('aria-pressed',String(index === i));});
        contrast.querySelectorAll('.chip2.bad').forEach(chip => {chip.hidden = index === 1;});
        contrast.querySelectorAll('.chip2.good').forEach(chip => {chip.hidden = index !== 1;});
      }
      buttons.forEach((button,i) => button.addEventListener('click',() => select(i)));
      select(0); instances.set(contrast,() => {});
    }
    const reel = root.querySelector('#ureel');
    if (reel && !instances.has(reel)) {
      let frame = 0;
      const cards = [...reel.querySelectorAll('.uc')];
      const paint = () => {
        frame = 0;
        const center = reel.scrollLeft + reel.clientWidth/2;
        const values = cards.map(card => {
          const base = card.offsetLeft + card.offsetWidth/2;
          return Math.max(0,1-Math.abs(center-base)/(card.offsetWidth*1.25));
        });
        cards.forEach((card,i) => {
          const strength = values[i]; card.style.transform = `scale(${0.8 + 0.2*strength})`;
          card.style.zIndex = String(Math.round(strength*10));
          card.querySelector('.vf').style.opacity = String(1-strength);
          card.classList.toggle('mid',strength > 0.65);
        });
      };
      const schedule = () => {if (!frame) frame = requestAnimationFrame(paint);};
      const move = direction => {
        const distance = cards.length > 1 ? cards[1].offsetLeft - cards[0].offsetLeft : reel.clientWidth;
        reel.scrollBy({left:distance*direction,behavior:behavior()});
      };
      reel.closest('section').querySelectorAll('[data-rh-reel-dir]').forEach(button => button.addEventListener('click',() => move(Number(button.dataset.rhReelDir))));
      reel.addEventListener('keydown',event => {
        if (event.target !== reel || !['ArrowLeft','ArrowRight','Home','End'].includes(event.key)) return;
        event.preventDefault();
        if (event.key === 'Home' || event.key === 'End') reel.scrollTo({left:event.key === 'Home' ? 0 : reel.scrollWidth,behavior:behavior()});
        else move(event.key === 'ArrowRight' ? 1 : -1);
      });
      reel.addEventListener('scroll',schedule,{passive:true});
      const resize = 'ResizeObserver' in window ? new ResizeObserver(schedule) : null;
      resize?.observe(reel);schedule();
      instances.set(reel,() => {resize?.disconnect(); cancelAnimationFrame(frame);});
    }
    root.querySelectorAll('#home-faq details').forEach(details => {
      if (instances.has(details)) return;
      details.addEventListener('toggle',() => {const icon = details.querySelector('summary span');if (icon) icon.textContent = details.open ? '\u2212' : '+';});instances.set(details,() => {});
    });
    root.querySelectorAll('[data-home-shop]').forEach(link => {
      const form = link.closest('form[data-coras-form]');
      if (!form || instances.has(link)) return;
      const box = form.closest('[data-unc-buy]');
      const base = box?.dataset.homeProductUrl || link.getAttribute('href') || '';
      const sync = () => {
        try {
          const url = new URL(base, location.origin);
          const id = form.elements.id?.value;
          if (id) url.searchParams.set('variant', id);
          else url.searchParams.delete('variant');
          link.href = url.pathname + url.search;
        } catch (_) {}
      };
      form.addEventListener('change', sync);
      form.addEventListener('submit', event => {
        event.preventDefault();
        if (link.getAttribute('aria-disabled') === 'true') return;
        sync();
        if (link.href) location.assign(link.href);
      });
      sync();
      instances.set(link, () => {});
    });
  }
  document.addEventListener('shopify:section:load',event => init(event.target));
  document.addEventListener('shopify:section:unload',event => event.target.querySelectorAll('#results,#science,#mben,#ureel,#home-faq details').forEach(node => {instances.get(node)?.();instances.delete(node);}));
  window.UnchemedHome = Object.freeze({init});
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',() => init(),{once:true});else init();
})();
